import Api, { handleData, handleError } from '../Api';
import request from '../request';

import { url } from './config';
import { BspData } from './types';

import { MatchWithVoucherBody } from './context/context';

class ExtendedApi extends Api<BspData> {
    uploadDataFromFile(body: Array<Partial<BspData>>) {
        return request.post(`${url}-upload-from-file`, body).then(handleData).catch(handleError);
    }
    matchWithVoucher(body: MatchWithVoucherBody) {
        return request.put(`${url}-match-with-voucher`, body).then(handleData).catch(handleError);
    }
    query(query: any) {
        return request.get(`${url}-query`, { params: query }).then(handleData).catch(handleError);
    }
    updateDocumentApproval(documentId: string, isApproved: boolean) {
        return request
            .put(`${url}-update-document-approval`, { documentId, isApproved })
            .then(handleData)
            .catch(handleError);
    }
    exportBranchData(params: { fromFileDate?: string; toFileDate?: string; companyIataCode: string }) {
        return request
            .get(`${url}-export`, { params, responseType: 'blob' })
            .then((res) => {
                const blob = new Blob([res.data], { type: 'text/csv' });
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = `bsp-export-${params.companyIataCode}.csv`;
                link.click();
                window.URL.revokeObjectURL(downloadUrl);
            })
            .catch(handleError);
    }
}

const api = new ExtendedApi(url);

export default api;
